export default function sidequestMiddleware(config) {
	const {map} = config;

	return (store) => (next) => async (action) => {
		let mappedAction = await map(action);

		if (mappedAction) {
			console.log(`[Sidequest Middleware] Action ${action.type} mapped to ${mappedAction.type}:`, {
				before: action,
				after: mappedAction
			});
			store.dispatch(mappedAction);
		}

		return next(action);
	};
}
